module.exports = __webpack_public_path__ + "img/footer-px-logo.e21adfbc.png";